module.exports = __webpack_public_path__ + "img/ESR-logo-min.878b6f08.png";